import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewInvoice from "./pages/NewInvoice";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import AddressBook from "./pages/AddressBook";
import Skus from "./pages/Skus";
import Company from "./pages/Company";
import Settings from "./pages/Settings";
import Shipments from "./pages/Shipments";
import Reports from "./pages/Reports";
import Expenses from "./pages/Expenses";
import Bank from "./pages/Bank";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/invoices/new" element={<Protected><NewInvoice /></Protected>} />
            <Route path="/invoices/:id/edit" element={<Protected><NewInvoice /></Protected>} />
            <Route path="/invoices/:id" element={<Protected><InvoiceDetail /></Protected>} />
            <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
            <Route path="/shipments" element={<Protected><Shipments /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
            <Route path="/bank" element={<Protected><Bank /></Protected>} />
            <Route path="/parties" element={<Protected><AddressBook /></Protected>} />
            <Route path="/skus" element={<Protected><Skus /></Protected>} />
            <Route path="/company" element={<Protected><Company /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
